import PluginCss from '!raw-loader!react-datepicker/dist/react-datepicker.css';
import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import Select from '../Selectors/Select/Select';
import DatePicker from 'react-datepicker';
import { ReactComponent as SvgSearch } from '@img/icons/search.svg';
const Container = styled.section `
  ${PluginCss}
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('accentColorAlt', brand.greyVeryLight)};
  ${setCssVar('bgColor', brand.greyVeryLight)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.black)};

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('accentColorAlt', brand.rss.grey)};
    ${setCssVar('bgColor', brand.rss.grey)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('accentColorAlt', brand.apl.green)};
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  display: flex;
  align-items: center;

  color: ${cssVar('fgColor')};
  border-bottom: 6px solid ${cssVar('accentColorAlt')};

  ${({ theme }) => {
    switch (theme) {
        case 'lightGrey':
            return css `
          background: ${cssVar('bgColor')};
          color: ${cssVar('fgColor')};
        `;
        case 'white':
            return css `
          background: ${cssVar('bgColorAlt')};
          color: ${cssVar('fgColorAlt')};
        `;
    }
}}

  ${({ alignment }) => {
    switch (alignment) {
        case 'left':
            return css `
          justify-content: flex-start;
        `;
        case 'center':
            return css `
          justify-content: center;
        `;
        case 'right':
            return css `
          justify-content: flex-end;
        `;
    }
}}

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 24px;
  }

  @media ${from(Device.Desktop)} {
    padding: 24px 48px;
  }

  @media ${from(Device.DesktopLarge)} {
    padding: 24px 160px;
  }
`;
const Title = styled.h3 `
  display: block;
  flex: 0 0 auto;
  ${fonts.sourceSansPro.semiBold};
  font-size: 20px;
  line-height: 28px;

  @media ${from(Device.Desktop)} {
    font-size: 24px;
    line-height: 34px;
  }
`;
const FilterList = styled.div `
  display: flex;
  flex: 1 1 auto;
`;
const Filter = styled.div `
  display: block;
  flex: 1 1 auto;
  margin-left: 16px;
  max-width: 248px;
  position: relative;

  @media ${from(Device.Desktop)} {
    margin-left: 30px;
  }
`;
const FilterDropdown = styled(Select) `
  display: block;
  width: 100%;
`;
const FilterSearch = styled.input `
  ${fonts.sourceSansPro.regular};
  display: block;
  appearance: none;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 9px;
  background-color: transparent;
  color: ${cssVar('fgColor')};
  font-size: 16px;
  line-height: 20px;
  height: 48px;
  padding: 0 30px 0 12px;
  width: 100%;

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
  }
`;
const FilterSearchButton = styled.button `
  border: 0;
  background: 0;
  position: absolute;
  min-height: 100%;
  top: 0;
  right: 8px;
`;
const FilterSearchIcon = styled(SvgSearch) `
  display: block;
  color: currentColor;
  height: 26px;
  width: 26px;

  @media ${from(Device.TabletLarge)} {
    height: 18px;
    width: 18px;
  }
`;
const DateLabel = styled.span `
  font-size: 14px;
  line-height: 18px;
  display: block;
  text-align: left;
  padding-left: 3px;
`;
const FilterDateRange = styled.div `
  ${fonts.sourceSansPro.regular};
  display: flex;
  align-items: center;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 9px;
  color: ${cssVar('fgColor')};
  font-size: 16px;
  line-height: 20px;
  height: 48px;
  padding: 0 6px;
  width: 100%;
  text-align: center;

  @media ${from(Device.Desktop)} {
    font-size: 18px;
    line-height: 24px;
  }
`;
const FilterDateRangeHolder = styled.div `
  flex: 0 0 50%;
  max-width: 50%;
  height: 100%;

  &:first-child {
    border-right: 1px solid ${brand.black};
  }

  &:last-child {
    ${DateLabel} {
      padding-left: 8px;
    }
    .react-datepicker-wrapper {
      padding-left: 5px;
    }
  }

  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    color: ${brand.black};
    background-color: ${brand.hta.greenLight};
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--keyboard-selected {
    color: ${brand.black};
    background-color: ${brand.hta.green};
    &:hover {
      color: ${brand.white};
      background-color: ${brand.hta.greenDark};
    }
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__day--selected {
    color: ${brand.white};
    background-color: ${brand.hta.purple};
  }
`;
const FilterDateRangeDate = styled(DatePicker) `
  ${fonts.sourceSansPro.regular};
  width: 100%;
  height: 26px;
  border: none;
  background: transparent;
`;
const FilterDateRangeDivider = styled.span `
  height: 100%;
  width: 0;
  margin: 0 6px;
  border-right: 1px solid ${cssVar('fgColor')};
`;
const CheckboxArea = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
const CheckboxAreaLabel = styled.p `
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 34px;
  flex: 1 0 100%;
`;
const FilterHolder = styled.span ``;
export default {
    CheckboxArea,
    CheckboxAreaLabel,
    Container,
    DateLabel,
    Filter,
    FilterDropdown,
    FilterSearch,
    FilterSearchButton,
    FilterSearchIcon,
    FilterDateRange,
    FilterDateRangeDate,
    FilterDateRangeDivider,
    FilterDateRangeHolder,
    FilterHolder,
    FilterList,
    Title,
};
